'use client'

import { useAction } from 'next-safe-action/hooks'

import { signOutAction } from '@/entities/auth/api/sign-out'
import { useServerErrorHandler } from '@/shared/config'
import { signOut } from '@/shared/lib'
import { useNavigationGuardEnabled } from '@/shared/model'

export const useSignOut = () => {
  const { handleServerError } = useServerErrorHandler()
  const { disableNavigationGuard } = useNavigationGuardEnabled()

  const action = useAction(signOutAction, {
    onSuccess: () => {
      disableNavigationGuard({
        callback: async () => {
          await signOut({
            redirect: '/guest/main',
          })
        },
      })
    },
    onError: ({ error }) => {
      handleServerError(error.serverError)
    },
  })

  return action
}
